import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import axios from "axios";
import airports from "../../data/airports.json";
import "./FlightSearchPage.css";
import FlightResults from "../FlightResults/FlightResults";

const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#fff",
    borderColor: state.isFocused ? "#fb923c" : "#ccc",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(251, 146, 60, 0.3)" : "none",
    borderRadius: "6px",
    fontSize: "1rem",
    minHeight: "45px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#fef3c7" : "#fff",
    color: "#1e293b",
    cursor: "pointer",
    fontSize: "0.95rem",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};

const filterAirports = (inputValue) => {
  return airports
    .filter(
      (a) =>
        a.iata &&
        a.iata.length === 3 &&
        `${a.iso} ${a.name} ${a.iata}`.toLowerCase().includes(inputValue.toLowerCase())
    )
    .map((a) => ({
      value: a.iata.toUpperCase(),
      label: `${a.iso} - ${a.name} (${a.iata.toUpperCase()})`,
    }));
};

const loadAirportOptions = (inputValue, callback) => {
  setTimeout(() => {
    callback(filterAirports(inputValue).slice(0, 25));
  }, 300);
};

const FlightSearchPage = ({setShowPopup}) => {
  const [searchData, setSearchData] = useState({
    from: "",
    to: "",
    departure: "",
    return: "",
  });
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    setShowPopup(true);
    setLoading(true);
    try {
      const response = await axios.get(`https://flightrecord.onrender.com/api/flights`, {
        params: {
          from: searchData.from,
          to: searchData.to,
          departureDate: searchData.departure || "",
          returnDate: searchData.return,
        },
      });
      setResults(response.data);
    } catch (err) {
      console.error("Flight search failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="flight-search-page">
      <div className="flight-search-form">
        <div className="form-group">
          <label>From</label>
          <AsyncSelect
            styles={customSelectStyles}
            loadOptions={loadAirportOptions}
            defaultOptions
            placeholder="Select departure airport"
            onChange={(selected) =>
              setSearchData((prev) => ({ ...prev, from: selected.value }))
            }
          />
        </div>
        <div className="form-group">
          <label>To</label>
          <AsyncSelect
            styles={customSelectStyles}
            loadOptions={loadAirportOptions}
            defaultOptions
            placeholder="Select destination airport"
            onChange={(selected) =>
              setSearchData((prev) => ({ ...prev, to: selected.value }))
            }
          />
        </div>
        <div className="form-group">
          <label>Departure Date</label>
          <input
            type="date"
            value={searchData.departure}
            onChange={(e) =>
              setSearchData((prev) => ({ ...prev, departure: e.target.value }))
            }
          />
        </div>
        <div className="form-group">
          <label>Return Date</label>
          <input
            type="date"
            value={searchData.return}
            onChange={(e) =>
              setSearchData((prev) => ({ ...prev, return: e.target.value }))
            }
          />
        </div>
        <button className="search-btn" onClick={handleSearch}>
          Search Flights
        </button>
      </div>

      {loading && <div className="loading">Searching flights...</div>}

    </section>
  );
};

export default FlightSearchPage;
